import { useStaticQuery, graphql } from "gatsby"

export const useActualites = () => {
  const data = useStaticQuery(
    graphql`
      query {
        allNodeActualites(sort: { fields: created, order: DESC }) {
          ...AllActualites
        }
        taxonomyTermZoneDefinie(name: { eq: "actualites" }) {
          ...AllActuTaxo
        }
      }
    `
  )
  return data
}

export const queryActualites = graphql`
  fragment AllActualites on node__actualitesConnection {
    edges {
      node {
        drupal_internal__nid
        title
        drupal_id
        created(locale: "fr", formatString: "DD MMMM YYYY")
        path {
          alias
        }
        status
        field_affichage_planifie
        field_date_de_depublication(formatString: "DD/MM/YYYY", locale: "fr")
        field_date_de_publication(formatString: "DD/MM/YYYY", locale: "fr")
        relationships {
          field_taxonomie_thematique {
            name
            path {
              alias
            }
          }
          field_image_actus {
            localFile {
              extension
              SlugifiedPublicUrl
            }
          }
        }
        body {
          summary
          processed
        }
      }
    }
  }
`

export const queryTaxo = graphql`
  fragment AllActuTaxo on taxonomy_term__zone_definie {
    drupal_internal__tid
    field_label
    description {
      processed
    }
  }
`
